import { Component } from '@angular/core';

@Component({
  selector: 'app-page-mant-lista-negra',
  templateUrl: './page-mant-lista-negra.component.html',
  styleUrl: './page-mant-lista-negra.component.css'
})
export class PageMantListaNegraComponent {

}
